import { AuthService } from "./../../shared/models/auth.service";
import { ContractTypeModel } from "./../../contractType/models/contractType.model";
import { ContractTypeGroupModel } from "./contracttypegroup.model";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";

@Injectable()
export class ContractTypeGroupService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetContractTypeGroupBySharedVehicleGroup(
    sharedVehicleGroupHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getContractTypeGroup = WeGoConfig.API_GET_CONTRACT_TYPE_GROUP_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getContractTypeGroup =
        getContractTypeGroup +
        "?" +
        queryString +
        "&sharedVehicleGroupHashId=" +
        sharedVehicleGroupHashId;
    } else {
      getContractTypeGroup =
        getContractTypeGroup +
        "?sharedVehicleGroupHashId=" +
        sharedVehicleGroupHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getContractTypeGroup, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportContractTypeGroupBySharedVehicleGroup(
    sharedVehicleGroupHashId: string,
    input?: DataListModel
  ): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getCompanyAdminUrl =
      WeGoConfig.API_EXPORT_CONTRACT_TYPE_GROUP_LIST +
      "?" +
      queryString +
      "&sharedVehicleGroupHashId=" +
      sharedVehicleGroupHashId;
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getCompanyAdminUrl, options);
  }
  public AssignContractGroupToSharedVehicleGroup(
    contractTypeGroupModel: ContractTypeGroupModel
  ): Observable<IAPIResponse> {
    let body = contractTypeGroupModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_ASSIGN_CONTRACT_TYPE_GROUP, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetContractTypeGroupByHashId(
    contractTypeGroupHashId: string
  ): Observable<IAPIResponse> {
    let getUrl =
      WeGoConfig.API_GET_CONTRACT_TYPE_GROUP_DETAIL +
      "?contractTypeGroupHashId=" +
      contractTypeGroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetContractTypeGroupBasicDetail(
    contractTypeGroupHashId: string
  ): Observable<IAPIResponse> {
    let getcontractTypeGroupUrl =
      WeGoConfig.API_GET_CONTRACTTYPEGROUP_BASIC_DETAIL +
      "?contractTypeGroupHashId=" +
      contractTypeGroupHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getcontractTypeGroupUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddContractType(
    contractTypeGroupModel: ContractTypeGroupModel
  ): Observable<IAPIResponse> {
    let body = contractTypeGroupModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_CONTRACT_TYPE_GROUP_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetInActiveReasonByHashId(
    contractTypeGroupHashId: string
  ): Observable<IAPIResponse> {
    let getUrl =
      WeGoConfig.API_GET_INACTIVE_REASON +
      "?contractTypeGroupHashId=" +
      contractTypeGroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetCurrencyByGroup(sharedVehicleGroupHashId: string) {
    let getUrl =
      WeGoConfig.API_GET_INSTANCE_BY_GROUP +
      "?sharedVehicleGroupHashId=" +
      sharedVehicleGroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public DeleteContractTypeGroup(
    contractypegroupHashId: string
  ): Observable<IAPIResponse> {
    let getUrl =
      WeGoConfig.API_GET_DELETE_GROUP +
      "?contractypegroupHashId=" +
      contractypegroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetVatSettingDropdownList(sharedVehicleGroupHashId: string) {
    let getUrl =
      WeGoConfig.API_GET_DROPDOWN_VATSETTING_LIST +
      "?sharedVehicleGroupHashId=" +
      sharedVehicleGroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetVatSettingDefaultValues(sharedVehicleGroupHashId: string) {
    let getUrl =
      WeGoConfig.API_GET_VATSETTING_DEFAULT_VALUES +
      "?sharedVehicleGroupHashId=" +
      sharedVehicleGroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetContractTypeBySVGHashId(sharedVehicleGroupHashId: string) {
    let getUrl =
      WeGoConfig.API_GET_CONTRACT_TYPE_BY_SVGHASHID +
      "?sharedVehicleGroupHashId=" +
      sharedVehicleGroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownListCTGBySVG(
    pageName: string,
    instanceHashId?: string,
    companyHashId?: string,
    sharedVehicleGroupHashId?: string,
    subscriptionHashId?: string
  ): Observable<IAPIResponse> {
    let getCTGUrl: string;
    switch (pageName) {
      case "Kick_Back_Report":
        getCTGUrl =
          WeGoConfig.API_GET_DROPDOWN_CTG_LIST_BY_SVG_KICK_BACK_REPORT;
        break;

      case "Terms_And_Condition":
        getCTGUrl =
          WeGoConfig.API_GET_DROPDOWN_CTG_LIST_BY_SVG_TERMS_AND_CONDITION;
        break;

      default:
        getCTGUrl = WeGoConfig.API_GET_CONTRACT_TYPE_BY_SVGHASHID;
        break;
    }

    if (instanceHashId) {
      getCTGUrl = getCTGUrl + "?instanceHashId=" + instanceHashId;
    }
    if (companyHashId) {
      getCTGUrl = getCTGUrl + "&companyHashId=" + companyHashId;
    }
    if (sharedVehicleGroupHashId) {
      getCTGUrl =
        getCTGUrl + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
    }

    if (subscriptionHashId) {
      getCTGUrl =
        getCTGUrl + "&SubscriptionHshId=" + subscriptionHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCTGUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contracttypegroup/models/contracttypegroup.service.ts